import * as ActionTypes from "./types";
import { actionCreator } from '../helpers/actionCreator';

export const selectScreenInThingsToDo = actionCreator(ActionTypes.SELECT_SCREEN_IN_THINGS_TO_DO);
